import { createAction } from "@cobuildlab/react-simple-state";
import { OnFetchContacts, OnFetchContactsError } from "./contacts-events";
import { fetchContacts } from "./contacts-services";

export const fetchContactsAction = createAction(
  OnFetchContacts,
  OnFetchContactsError,
  fetchContacts
);
